import type { AssistantDockKind } from '@shared/state/active-webview.ts';

/**
 * Dónde se incrusta el botón del asistente, o `null` para dejarlo flotando en la esquina.
 *
 * Con un WebView delante manda la barra de control, y nada más: la tabla sigue montada detrás
 * del mapa pero oculta (`display: none`), así que su hueco existe y no se ve. Acoplarse ahí
 * dejaría el botón invisible. Si esa vista no ofrece barra, flota, que es peor que estar
 * acoplado pero mejor que desaparecer.
 *
 * Sin WebView, una tabla dinámica en pantalla se lo lleva a su barra, junto al contador de
 * resultados.
 */
export function pickAssistantDock<T>(
  webViewActive: boolean,
  dockNodes: Record<AssistantDockKind, T | null>,
): T | null {
  if (webViewActive) return dockNodes.controlBar;
  return dockNodes.tableToolbar;
}
